// extracted by mini-css-extract-plugin
module.exports = {"section":"index-module--section--3PwVh","group":"index-module--group--33Nmi","groupHeader":"index-module--groupHeader--27l1d","members":"index-module--members--3tfr1"};